import { Card, CardBody, CardHeader, Col, Container, Row, } from "reactstrap";
import { H3, H4, H6, LI, P, UL } from "../../AbstractElements";
import { maskItem, URL_API } from "../../utils/helper/helpers";

import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import '../../utils/helper/style.css';

import { formatPrice } from "../../utils/helper/helpers";
import useInfosEts from "../../Pages/InfosEts/InfoApi";
import Chart from "../../Pages/versements_v2/apiVersement";


// Types
type Verse = { [key: string]: any };

interface VersementAggregated {
    qts: number;
    qtt: number;
    mt: number;
    tqts: number;
    tqtt: number;
    tmt: number;
    name: string;
}

interface VersementsData {
    success: boolean;
    diamond: VersementAggregated;
    diamond_sougueta: VersementAggregated;
    cimaf: VersementAggregated;
    ciment_de_guinee: VersementAggregated;
    versements: Verse[];
    [key: string]: VersementAggregated | Verse[] | boolean; // Signature d'index ajoutée
}

const VersementTableau = () => {

    const Token = JSON.parse(localStorage.getItem("login")!);
    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Verse[]>([]);
    const [data, setData] = useState<VersementsData | null>(null);
    const [refresh, setRefresh] = useState(false);
    const [chartData, setChartData] = useState<number[]>([0, 0, 0]);
    const [cimafStockDisponible, setCimafStockDisponible] = useState<number>(0);
    const [monthFilter, setMonthFilter] = useState<string>("");
    const [etsFilter, setEtsFilter] = useState<string>("");



    const filterByMonth = (versements: Verse[], month: string) => {
        if (!month) return versements;

        return versements.filter((item) => {
            // Vérifier que la date existe
            if (item.pv_date_paiement) {
                const date = new Date(item.pv_date_paiement);  // Log pour vérifier la date et le mois

                return date.getMonth() + 1 === parseInt(month); // Comparer le mois
            }
            return false; // Si pv_date_paiement est manquante ou invalide, on l'ignore
        });
    };

    const filterByEts = (versements: Verse[], code: string) => {
        if (!code) return versements;

        const transformCode = code.toLocaleLowerCase()
        return versements.filter((item) => (item.ets_code && item.ets_code.toLowerCase().includes(transformCode)))
    };

    // Fetch data from API
    const fetchVersements = useCallback(async () => {
        try {
            const response = await axios.get(`${URL_API}/versement/all`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.data.success) {
                setData(response.data);
                setChartData([
                    response.data.diamond.qtt ?? 0,
                    response.data.diamond_sougueta.qtt ?? 0,
                    // response.data.cimaf.qtt ?? 0,
                    response.data.ciment_de_guinee.qtt ?? 0,
                ]);
                setCimafStockDisponible(response.data.cimaf.qtt)
            }
        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    useEffect(() => {
        if (data) {
            // Filtrage par texte
            const filteredByText = data.versements.filter((item) =>
                ["pv_num_paiement", "materiel", "pv_date_paiement", "four_name", "ets_name", "ets_code"].some((key) =>
                    item[key]?.toLowerCase().includes(filterText.toLowerCase())
                )
            );
            // Filtrage par mois
            const filterByMonths = filterByMonth(filteredByText, monthFilter);
            const finalFiltered = filterByEts(filterByMonths, etsFilter);

            setFilteredItems(finalFiltered ?? []);
        }
    }, [filterText, data, monthFilter, etsFilter]);

    // Initial data fetch
    useEffect(() => {
        fetchVersements();
    }, [fetchVersements]);

    const cardValeur = ({ value }: { value: Verse[] }) => {
        let payed = 0;
        let payed_montant = 0;
        let attente = 0;
        let attente_montant = 0;
        let total = 0;
        let total_montant = 0;

        // Utilisation de `forEach` pour mettre à jour les compteurs
        value.forEach((item) => {
            if (item.status === 'Attente') {
                attente += 1;
                attente_montant += Number(item.pv_montant);
            } else if (item.status === 'Payé') {
                payed += 1;
                payed_montant += Number(item.pv_montant);
            }
            total += 1;
            total_montant += Number(item.montant);
        });
        return (
            <Row>
                <Col sm="12">
                    <Card className="progress-items pb-0 bg-light-info">
                        <CardHeader className="pb-4 bg-light-info">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <H4>
                                        <span className="text-dark fw-bold">{total.toLocaleString("gn-GN")}</span>
                                    </H4>
                                    <H6 className="f-20 f-w-600 mt-3">
                                        Total Achats
                                    </H6>
                                    <H3 className="f-15 font-light f-w-600 mt-3">
                                        Dont <span className="text-dark fw-bold">{maskItem(formatPrice(total_montant))}</span>
                                    </H3>
                                </div>
                                <div>
                                    <i className="icofont icofont-bricks f-80"></i>
                                </div>
                            </div>
                        </CardHeader>
                    </Card>
                </Col>
                <Col md="6">
                    <Card className="progress-items pb-0 bg-light-warning">
                        <CardHeader className="pb-4 bg-light-warning">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <H4>
                                        <span className="text-dark fw-bold">{attente.toLocaleString("gn-GN")}</span>
                                    </H4>
                                    <H6 className="f-20 f-w-600 mt-3 text-white">
                                        Paiements En Attente
                                    </H6>
                                    <H3 className="f-15 text-white f-w-600 mt-3">
                                        Dont <span className="text-dark fw-bold">{maskItem(formatPrice(attente_montant))}</span>
                                    </H3>
                                </div>
                                <div>
                                    <i className="icofont icofont-bank-transfer f-80"></i>
                                </div>
                            </div>
                        </CardHeader>
                    </Card>
                </Col>
                <Col md="6">
                    <Card className="progress-items pb-0 bg-light-primary">
                        <CardHeader className="pb-4 bg-light-primary">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <H4>
                                        <span className="text-dark fw-bold">{payed.toLocaleString("gn-GN")}</span>
                                    </H4>
                                    <H6 className="f-20 f-w-600 mt-3">
                                        Paiements Effectués
                                    </H6>
                                    <H3 className="f-15 font-light f-w-600 mt-3">
                                        Dont <span className="text-dark fw-bold">{maskItem(formatPrice(payed_montant))}</span>
                                    </H3>
                                </div>
                                <div>
                                    <i className="icofont icofont-pay f-80"></i>
                                </div>
                            </div>
                        </CardHeader>
                    </Card>
                </Col>
            </Row>
        )
    };
    return (

        <Container fluid>
            {/* <H4 className="my-2">VERSEMENT</H4> */}
            <Row>
                <Col sm="4" md="4" >
                    <Card className="total-project p-0">
                        <CardBody className="p-0">
                            <Row>

                                <Col xs="12">
                                    {chartData && <Chart chartData={chartData} />}

                                    <UL className="project-details simple-list">
                                    <Card className="progress-items bg-light-success mb-0">
                                        <CardHeader className="p-2 bg-light-success">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H6 className="f-w-600">
                                                        DIAMOND KAGBLEN
                                                    </H6>
                                                    <H6>
                                                        <span className="text-dark fw-bold">{data?.diamond.qtt.toLocaleString('gn-GN')} Tonnes</span>
                                                    </H6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Card>
                                    <Card className="progress-items bg-light-info mb-1">
                                        <CardHeader className="p-2 bg-light-info">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H6 className="f-w-600">
                                                        DIAMOND SOUGUETA
                                                    </H6>
                                                    <H6>
                                                        <span className="text-dark fw-bold">{data?.diamond_sougueta.qtt.toLocaleString('gn-GN')} Tonnes</span>
                                                    </H6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Card>
                                    <Card className="progress-items bg-light-warning mb-1">
                                        <CardHeader className="p-2 bg-light-warning">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H6 className="f-w-600">
                                                        CIMENT DE GUINEE
                                                    </H6>
                                                    <H6>
                                                        <span className="text-dark fw-bold">{data?.ciment_de_guinee.qtt.toLocaleString('gn-GN')} Tonnes</span>
                                                    </H6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Card>
                                    <Card className="progress-items bg-light-dark">
                                        <CardHeader className="p-2 bg-light-dark">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H6 className="f-w-600">
                                                        CIMAF
                                                    </H6>
                                                    <H6>
                                                        <span className="text-dark fw-bold">{maskItem(formatPrice(cimafStockDisponible))}</span>
                                                    </H6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Card>
                                </UL>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col sm="8">
                    {cardValeur({ value: filteredItems })}
                </Col>
            </Row>
        </Container>

    )
}

export default VersementTableau